"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnableAmendmentFlags = void 0;
var EnableAmendmentFlags;
(function (EnableAmendmentFlags) {
    EnableAmendmentFlags[EnableAmendmentFlags["tfGotMajority"] = 65536] = "tfGotMajority";
    EnableAmendmentFlags[EnableAmendmentFlags["tfLostMajority"] = 131072] = "tfLostMajority";
})(EnableAmendmentFlags = exports.EnableAmendmentFlags || (exports.EnableAmendmentFlags = {}));
//# sourceMappingURL=enableAmendment.js.map